import Style from "../scss/text.module.scss";

export function ParagraphComponent(props) {
    return (
        <p className={`${Style.p} ${props.styleGroup}`}>{props.children}</p>
    );
}